<template>
  <section class="slides pt-5" style="margin-top: 8rem;">
    <div class="container-fluid">
      <div class="social-media-header d-none d-xl-flex">
        <i class="fa fa-facebook icon"></i>
        <i class="fa fa-instagram icon"></i>
        <i class="fa fa-twitter icon"></i>
        <i class="fa fa-youtube-play icon"></i>
        <img src="../assets/images/groups/line.png" alt="line"/>
        <img src="../assets/images/groups/arrow.png" alt="arrow" class="mt-3"/>
        <a href="/company-profile" style="text-decoration: none;" class="social-media-title-header">Profile Company</a>
      </div>
      <div class="container container-width">
        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
          <button
              class="btn-chevron btn text-white"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
              style="left: -40px;"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
              class="btn-chevron btn text-white"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
              style="right: -40px;"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
          <div class="carousel-indicators">
            <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="0"
                class="active"
                aria-current="true"
                aria-label="Slide 1"
            ></button>
            <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="1"
                aria-label="Slide 2"
            ></button>
            <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="2"
                aria-label="Slide 3"
            ></button>
            <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="3"
                aria-label="Slide 4"
            ></button>
            <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="4"
                aria-label="Slide 5"
            ></button>
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <!-- <img src="..." class="d-block w-100" alt="..."> -->
              <div class="row slide">
                <div class="col-xl-4 slide-text slide-1 p-0">
                  <div class="slide-title text-light">
                    Training & Professional Development
                  </div>
                  <div class="slide-para text-light">
                    GVC has a strong track record of designing and delivering
                    high quality Training & solutions across a range of Public
                    and Private Sectors. We take pride in our achievements by
                    our young champions in regional and international
                    competitions. With our team of experts, we offers you a
                    wide range of training, onsite and virtual, for skills,
                    competitions training and professional development .
                  </div>
                  <!-- <div class="slide-deco"></div> -->
                  <img alt="line" src="../assets/images/groups/slide-line.png"/>
                </div>
                <div class="col-xl-8 p-0">
                  <img
                      alt="slide1"
                      class="slide-img"
                      src="../assets/images/groups/slide1.png"
                  />
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <!-- <img src="..." class="d-block w-100" alt="..." /> -->
              <div class="row slide">
                <div class="col-xl-8 p-0">
                  <img
                      alt="slide1"
                      class="slide-img"
                      src="../assets/images/groups/slide2.png"
                  />
                </div>
                <div class="col-xl-4 slide-text slide-2 p-0">
                  <div class="slide-title text-light">Education Events</div>
                  <div class="slide-para text-light">
                    GVE offers a comprehensive range of effective organization
                    services to deliver creative ideas, flawless execution and
                    great attention to detail. With our creative team we are
                    committed to providing the right creative mindset to meet
                    the world standards requested by our clientele. With
                    Global Vision events Management we are much more than the
                    facilitators of your ideas; we are your event partners.
                  </div>
                  <!-- <div class="slide-deco"></div> -->
                  <img alt="line" src="../assets/images/groups/slide-line.png"/>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="row slide">
                <div class="col-xl-4 slide-text slide-3 p-0">
                  <div class="slide-title text-light">
                    Platform Development & Virtual Training
                  </div>
                  <div class="slide-para text-light">
                    GVC has a strong track record of designing and delivering
                    high quality Training & solutions across a range of Public
                    and Private Sectors. We take pride in our achievements by
                    our young champions in regional and international
                    competitions. With our team of experts, we offers you a
                    wide range of training, onsite and virtual, for skills,
                    competitions training and professional development .
                  </div>
                  <!-- <div class="slide-deco"></div> -->
                  <img alt="line" src="../assets/images/groups/slide-line.png"/>
                </div>
                <div class="col-xl-8 p-0">
                  <img
                      alt="slide1"
                      class="slide-img"
                      src="../assets/images/groups/slide3.png"
                  />
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="row slide">
                <div class="col-xl-8 p-0">
                  <img
                      alt="slide1"
                      class="slide-img"
                      src="../assets/images/groups/slide4-2.png"
                  />
                </div>
                <div class="col-xl-4 slide-text slide-4 p-0">
                  <div class="slide-title text-light">
                    Education Business Consultation
                  </div>
                  <div class="slide-para text-light" style="margin: 0;">
                    <p class="fw-bold slide-para text-light" style="margin: 0;">NEWS SCHOOLS:</p>
                    <ul class="slide-para text-light">
                      <li>Business plan and licensing</li>
                      <li>Organization artifacts preparation</li>
                      <li>Educational stream</li>
                      <li>Support services</li>
                    </ul>
                    <p class="fw-bold slide-para text-light" style="margin: 0;">EXISTING SCHOOLS:</p>
                    <ul class="slide-para text-light">
                      <li>Manpower, business and facility Management</li>
                      <li>Deploying Technology</li>
                      <li>Unique extracurricular programs & After School Activities</li>
                      <li>IT Operations and development</li>
                      <li>Community and Users</li>
                    </ul>
                  </div>
                  <!-- <div class="slide-deco"></div> -->
                  <img alt="line" src="../assets/images/groups/slide-line.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container text-center mt-5">
      <img
          alt="slides-footer"
          class="slides-footer img-fluid"
          src="../assets/images/groups/slides-footer.png"
      />
    </div>
  </section>

  <section class="gv-group">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xxl-4 col-lg-12">
          <div class="section-title">Global Vision Group</div>
          <img alt="line" src="../assets/images/groups/dark-line.png" class="mb-5"/>
        </div>
        <div class="col-xxl-8 col-lg-12">
          <div class="row">
            <div class="col-xl-4 col-lg-12 card-custom">
              <div class="gv-group-card">
                <div class="crs"></div>
                <img class="img-fluid group-img img-height-auto" alt="card-img"
                     src="../assets/images/groups/card1.png"/>
                <div class="card-inner">
                  <div class="card-number">01.</div>
                  <div class="card-text color-light">
                    Global Vision <br> Training & Education <br> Consultancy
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12 card-custom">
              <div class="gv-group-card">
                <div class="crs"></div>
                <img class="img-fluid group-img img-height-auto" alt="card-img"
                     src="../assets/images/groups/card2.png"/>
                <div class="card-inner">
                  <div class="card-number">02.</div>
                  <div class="card-text color-light">
                    Global Vision <br> Event Management
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12 card-custom">
              <div class="gv-group-card">
                <div class="crs"></div>
                <img class="img-fluid group-img img-height-auto" alt="card-img"
                     src="../assets/images/groups/card3.png"/>
                <div class="card-inner">
                  <div class="card-number">03.</div>
                  <div class="card-text color-light">Robocup</div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12 card-custom">
              <div class="gv-group-card">
                <div class="crs"></div>
                <img class="img-fluid group-img img-height-auto" alt="card-img"
                     src="../assets/images/groups/card4.png"/>
                <div class="card-inner">
                  <div class="card-number">04.</div>
                  <div class="card-text color-light">Global Arts <br> Academy</div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12 card-custom">
              <div class="gv-group-card">
                <div class="crs"></div>
                <img class="img-fluid group-img img-height-auto" alt="card-img"
                     src="../assets/images/groups/card5.png"/>
                <div class="card-inner">
                  <div class="card-number">05.</div>
                  <div class="card-text color-light">
                    Global Music Academy
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-12 card-custom">
              <div class="gv-group-card">
                <div class="crs"></div>
                <img class="img-fluid group-img img-height-auto" alt="card-img"
                     src="../assets/images/groups/card6.png"/>
                <div class="card-inner">
                  <div class="card-number">06.</div>
                  <div class="card-text color-light">Mathnasium</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="group-details">
    <div id="CONSULTANCY" class="group">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 col-md-12 video-container p-lg-5 order-2">
            <div
                class="video d-flex align-items-center justify-content-center"
            >
              <img
                  alt="video"
                  src="../assets/images/groups/A.png"
                  class="img-fluid"
              />
            </div>
            <a href="https://drive.google.com/drive/folders/1F2N7Jo34gVlhbe59w3dW0wBTXa1N6N2n" target="_blank"
               style="text-decoration: none; color: black;" class="profile-link d-flex align-items-center my-2">
              <div>GVC Profile</div>
              <img
                  alt="arrow"
                  src="../assets/images/groups/link.png"
                  class="link-icon ms-2"
              />
            </a>
          </div>
          <div class="col-xl-6 col-md-12 text-container p-5">
            <div class="group-title color-dark mb-5">
              Global Vision Training and Educational Consultancy
            </div>
            <img
                alt="line"
                src="../assets/images/groups/dark-line.png"
                class="mb-5"
            />
            <div class="group-text color-dark">
              At GVC we believe that through education, we can change the
              world and can move forward for a better society. Our mission is
              to improve the educational system in the UAE and make it as one
              of the most leading pioneer systems in the world through
              supporting our partners and clients with all the tools possible
              to succeed in their mission. From training camps to new schools
              establishment, we are an extension to your creative and
              executional abilities. Quite simply, an extension of YOU.
            </div>
          </div>
        </div>
      </div>
      <div class="group-offer offer1">
        <div class="container">
          <div class="row">
            <img src="../assets/images/groups/line-offer.png"/>
            <div class="col-lg-4 py-5 offer" id="offer1-1">
              <div class="offer-title color-light mb-4">01.</div>
              <div class="offer-title color-light">
                Training & Professional Development
              </div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer1-2">
              <div class="offer-title color-light mb-4">02.</div>
              <div class="offer-title color-light">
                Education Business Consultation
              </div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer1-3">
              <div class="offer-title color-light mb-4">03.</div>
              <div class="offer-title color-light">
                Educational Content Production
              </div>
            </div>
          </div>
          <div class="row">
            <img src="../assets/images/groups/line-offer.png" class="d-none d-xl-block"/>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer1-4">
              <div class="offer-title color-light mb-4">04.</div>
              <div class="offer-title color-light"> Students of Determination Training</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer1-5">
              <div class="offer-title color-light mb-4">05.</div>
              <div class="offer-title color-light">Assessment, Inspection & evaluation</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer1-6">
              <div class="offer-title color-light mb-4">06.</div>
              <div class="offer-title color-light">Recruitment & Qualification</div>
            </div>
            <img
                src="../assets/images/groups/line-offer.png"
                class="d-none d-xl-block"
            />
          </div>
        </div>
        <div class="circles d-xl-none">
          <div class="circle current" @click.prevent="openTab($event,'offer1-1', 1)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer1-2', 1)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer1-3', 1)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer1-4', 1)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer1-5', 1)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer1-6', 1)"></div>
        </div>
      </div>
      <div class="form-section">
        <div class="d-flex justify-content-center flex-column align-items-center">
          <div class="row mb-5">
            <div class="col-xl-12">
              <a href="/contact-us" class="btn-contact" style="text-decoration: none;">Tell
                us about your Project</a>
            </div>
          </div>

          <!--
                          <button class="btn-learn mb-5">Learn More</button>
          -->
        </div>
      </div>
    </div>
    <div id="MANAGEMENT" class="group group-grey">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 video-container p-lg-5 order-2">
            <div
                class="video d-flex align-items-center jusstify-content-center"
            >
              <img
                  alt="video"
                  src="../assets/images/groups/B.png"
                  class="img-fluid"
              />
            </div>
            <a href="https://drive.google.com/drive/folders/1F2N7Jo34gVlhbe59w3dW0wBTXa1N6N2n" target="_blank"
               style="text-decoration: none; color: black;" class="profile-link d-flex align-items-center my-2">
              <div>GVE Profile</div>
              <img
                  alt="arrow"
                  src="../assets/images/groups/link.png"
                  class="link-icon ms-2"
              />
            </a>
          </div>
          <div class="col-xl-6 text-container p-5">
            <div class="group-title color-dark mb-5">
              Global Vision Events Management
            </div>
            <img
                alt="line"
                src="../assets/images/groups/dark-line.png"
                class="mb-5"
            />
            <div class="group-text color-dark">
              GVE intends to be the leading experiential, most innovative and
              creative agency in event management in the UAE (and worldwide),
              by providing services that exceeds the expectations of our
              esteemed clients. From moments to movements, our game-changing
              ideas allow our clients to show up and stand out.
            </div>
          </div>
        </div>
      </div>
      <div class="group-offer offer2">
        <div class="container">
          <div class="row">
            <img src="../assets/images/groups/line-offer.png"/>
            <div class="col-lg-4 py-5 offer" id="offer2-1">
              <div class="offer-title color-light mb-4">01.</div>
              <div class="offer-title color-light">
                Local & International Events
              </div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer2-2">
              <div class="offer-title color-light mb-4">02.</div>
              <div class="offer-title color-light">Virtual Events</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer2-3">
              <div class="offer-title color-light mb-4">03.</div>
              <div class="offer-title color-light">
                Events Logistics Management
              </div>
            </div>
          </div>
          <div class="row">
            <img
                src="../assets/images/groups/line-offer.png"
                class="d-none d-xl-block"
            />
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer2-4">
              <div class="offer-title color-light mb-4">04.</div>
              <div class="offer-title color-light">Web App Development</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer2-5">
              <div class="offer-title color-light mb-4">05.</div>
              <div class="offer-title color-light">Branding & Design</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer2-6">
              <div class="offer-title color-light mb-4">06.</div>
              <div class="offer-title color-light">
                Media Planning & Buying
              </div>
            </div>
            <img
                src="../assets/images/groups/line-offer.png"
                class="d-none d-xl-block"
            />
          </div>
        </div>
        <div class="circles d-xl-none">
          <div class="circle current" @click.prevent="openTab($event,'offer2-1', 2)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer2-2', 2)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer2-3', 2)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer2-4', 2)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer2-5', 2)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer2-6', 2)"></div>
        </div>
      </div>
      <div class="form-section">
        <div class="d-flex justify-content-center flex-column align-items-center">
          <div class="row mb-5">
            <div class="col-xl-12">
              <a href="/contact-us" class="btn-contact" style="text-decoration: none;">Tell
                us about your Project</a>
            </div>
          </div>

          <!--
                          <button class="btn-learn mb-5">Learn More</button>
          -->
        </div>
      </div>
    </div>
    <div id="SKILLS" class="group">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 video-container p-lg-5 order-2">
            <div
                class="video d-flex align-items-center jusstify-content-center"
            >
              <img
                  alt="video"
                  src="../assets/images/groups/C.png"
                  class="img-fluid"
              />
            </div>
            <a href="https://drive.google.com/drive/folders/1F2N7Jo34gVlhbe59w3dW0wBTXa1N6N2n" target="_blank"
               style="text-decoration: none; color: black;" class="profile-link d-flex align-items-center my-2">
              <div>Skills Academy Profile</div>
              <img
                  alt="arrow"
                  src="../assets/images/groups/link.png"
                  class="link-icon ms-2"
              />
            </a>
            <a href="https://robocup.ae/" target="_blank"
               style="text-decoration: none; color: black;" class="profile-link d-flex align-items-center my-2">
              <div>Robocup Website</div>
              <img
                  alt="arrow"
                  src="../assets/images/groups/link.png"
                  class="link-icon ms-2"
              />
            </a>
          </div>
          <div class="col-xl-6 text-container p-5">
            <div class="group-title color-dark mb-5">
              Global Vision Skills Academy
            </div>
            <img
                alt="line"
                src="../assets/images/groups/dark-line.png"
                class="mb-5"
            />
            <div class="group-text color-dark">
              RoboCup UAE promots science and technologies in the fields of
              robotics and artificial intelligence (AI) through appealing and
              challenging competitions for research institutes, universities
              and schools. RoboCup in the UAE comprises a large community
              with RoboCupJunior UAE activities at schools and RoboCup UAE
              Major teams at universities as well as research institutes.
              GVTRONICS (Electronics Online Store) is one of the leading
              suppliers of electronics ware in the region. We provide you with
              a portfolio of world-renowned brands, in the United Arab
              Emirates (UAE) and in select markets world-wide.
            </div>
          </div>
        </div>
      </div>
      <div class="group-offer offer3">
        <div class="container">
          <div class="row">
            <img src="../assets/images/groups/line-offer.png"/>
            <div class="col-lg-4 py-5 offer" id="offer3-1">
              <div class="offer-title color-light mb-4">01.</div>
              <div class="offer-title color-light">Robotics & Electronics Courses & Bootcamps</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer3-2">
              <div class="offer-title color-light mb-4">02.</div>
              <div class="offer-title color-light">Project Consultation</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer3-3">
              <div class="offer-title color-light mb-4">03.</div>
              <div class="offer-title color-light">Local & International Competitions</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer3-4">
              <div class="offer-title color-light mb-4">04.</div>
              <div class="offer-title color-light"> After School Activities & Summer Camps</div>
            </div>
            <div class="col-lg-4 py-5 d-none d-xl-block offer" id="offer3-5">
              <div class="offer-title color-light mb-4">05.</div>
              <div class="offer-title color-light">World Skills Training</div>
            </div>
            <img
                src="../assets/images/groups/line-offer.png"
                class="d-none d-xl-block"
            />
          </div>
        </div>
        <div class="circles d-xl-none">
          <div class="circle current" @click.prevent="openTab($event,'offer3-1', 3)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer3-2', 3)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer3-3', 3)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer3-4', 3)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer3-5', 3)"></div>
        </div>
      </div>
      <div class="form-section">
        <div class="d-flex justify-content-center flex-column align-items-center">
          <div class="row mb-5">
            <div class="col-xl-12">
              <a href="/contact-us" class="btn-contact" style="text-decoration: none;">Tell
                us about your Project</a>
            </div>
          </div>

          <!--
                          <button class="btn-learn mb-5">Learn More</button>
          -->
        </div>
      </div>
    </div>
    <div id="MUSIC" class="group group-grey">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 video-container p-lg-5 order-2">
            <div
                class="video d-flex align-items-center jusstify-content-center"
            >
              <img
                  alt="video"
                  src="../assets/images/groups/D.png"
                  class="img-fluid"
              />
            </div>
            <a href="https://drive.google.com/drive/folders/1F2N7Jo34gVlhbe59w3dW0wBTXa1N6N2n" target="_blank"
               style="text-decoration: none; color: black;" class="profile-link d-flex align-items-center my-2">
              <div>GMA Profile</div>
              <img
                  alt="arrow"
                  src="../assets/images/groups/link.png"
                  class="link-icon ms-2"
              />
            </a>
          </div>
          <div class="col-xl-6 text-container p-5">
            <div class="group-title color-dark mb-5">
              Global Music Academy
            </div>
            <img
                alt="line"
                src="../assets/images/groups/dark-line.png"
                class="mb-5"
            />
            <div class="group-text color-dark">
              At GVC we believe that through education, we can change the
              world and can move forward for a better society. Our mission is
              to improve the educational system in the UAE and make it as one
              of the most leading pioneer systems in the world through
              supporting our partners and clients with all the tools possible
              to succeed in their mission. From training camps to new schools
              establishment, we are an extension to your creative and
              executional abilities. Quite simply, an extension of YOU.
            </div>
          </div>
        </div>
      </div>
      <div class="group-offer offer4">
        <div class="container">
          <div class="row">
            <img src="../assets/images/groups/line-offer.png"/>
            <div class="col-lg-4 offer py-5" id="offer4-1">
              <div class="offer-title color-light mb-4">01.</div>
              <div class="offer-title color-light">Instrument Courses</div>
            </div>
            <div class="col-lg-4 offer py-5 d-none d-xl-block" id="offer4-2">
              <div class="offer-title color-light mb-4">02.</div>
              <div class="offer-title color-light">Vocal Courses</div>
            </div>
            <div class="col-lg-4 offer py-5 d-none d-xl-block" id="offer4-3">
              <div class="offer-title color-light mb-4">03.</div>
              <div class="offer-title color-light">Musical Events</div>
            </div>
            <img src="../assets/images/groups/line-offer.png" class="d-none d-xl-block"/>
          </div>
        </div>
        <div class="circles d-xl-none">
          <div class="circle current" @click.prevent="openTab($event,'offer4-1', 4)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer4-2', 4)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer4-3', 4)"></div>
        </div>
      </div>
      <div class="form-section">
        <div class="d-flex justify-content-center flex-column align-items-center">
          <div class="row mb-5">
            <div class="col-xl-12">
              <a href="/contact-us" class="btn-contact" style="text-decoration: none;">Tell
                us about your Project</a>
            </div>
          </div>

          <!--
                          <button class="btn-learn mb-5">Learn More</button>
          -->
        </div>
      </div>
    </div>
    <div id="ARTS" class="group">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 video-container p-lg-5 order-2">
            <div
                class="video d-flex align-items-center jusstify-content-center"
            >
              <img
                  alt="video"
                  src="../assets/images/groups/E.png"
                  class="img-fluid"
              />
            </div>
            <a href="https://drive.google.com/drive/folders/1F2N7Jo34gVlhbe59w3dW0wBTXa1N6N2n" target="_blank"
               style="text-decoration: none; color: black;" class="profile-link d-flex align-items-center my-2">
              <div>GAA Profile</div>
              <img
                  alt="arrow"
                  src="../assets/images/groups/link.png"
                  class="link-icon ms-2"
              />
            </a>
          </div>
          <div class="col-xl-6 text-container p-5">
            <div class="group-title color-dark mb-5">Global Arts Academy</div>
            <img
                alt="line"
                src="../assets/images/groups/dark-line.png"
                class="mb-5"
            />
            <div class="group-text color-dark">
              At Global Arts Academy, our courses are grounded in classical
              tradition moulded to incorporate modern learnings to ride with
              the changing times. Our dedicated and qualified team is our best
              asset and with their professional attitude and skills. We
              provide the ability to layout the basic foundation in both
              technical skills as well as to evolve conceptual skills needed
              to further their career in Arts. We provide high state of arts
              creative training services. Throughout the years we have
              produced champions in the UAE in International Competitions such
              as World Skills and World Skills Asia in the creative fields.
            </div>
          </div>
        </div>
      </div>
      <div class="group-offer offer5">
        <div class="container">
          <div class="row">
            <img src="../assets/images/groups/line-offer.png"/>
            <div class="col-lg-4 py-5 offer" id="offer5-1">
              <div class="offer-title color-light mb-4">01.</div>
              <div class="offer-title color-light">Digital Art Lessons</div>
            </div>
            <div class="col-lg-4 py-5 offer d-none d-xl-block" id="offer5-2">
              <div class="offer-title color-light mb-4">02.</div>
              <div class="offer-title color-light">Painting Lessons</div>
            </div>
            <div class="col-lg-4 py-5 offer d-none d-xl-block" id="offer5-3">
              <div class="offer-title color-light mb-4">03.</div>
              <div class="offer-title color-light">Craft Art Lessons</div>
            </div>
            <img src="../assets/images/groups/line-offer.png" class="d-none d-xl-block"/>
          </div>
        </div>
        <div class="circles d-xl-none">
          <div class="circle current" @click.prevent="openTab($event, 'offer5-1', 5)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer5-2', 5)"></div>
          <div class="circle" @click.prevent="openTab($event,'offer5-3', 5)"></div>
        </div>
      </div>
      <div class="form-section">
        <div class="d-flex justify-content-center flex-column align-items-center">
          <div class="row mb-5">
            <div class="col-xl-12">
              <a href="/contact-us" class="btn-contact" style="text-decoration: none;">Tell
                us about your Project</a>
            </div>
          </div>

          <!--
                          <button class="btn-learn mb-5">Learn More</button>
          -->
        </div>
      </div>
    </div>
    <div id="MATHNASIUM" class="group group-grey">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 video-container p-lg-5 order-2">
            <div
                class="video d-flex align-items-center jusstify-content-center"
            >
              <img
                  alt="video"
                  src="../assets/images/groups/F.png"
                  class="img-fluid"
              />
            </div>
            <a href="https://drive.google.com/drive/folders/1F2N7Jo34gVlhbe59w3dW0wBTXa1N6N2n" target="_blank"
               style="text-decoration: none; color: black;" class="profile-link d-flex align-items-center my-2">
              <div>Mathnasium Profile</div>
              <img
                  alt="arrow"
                  src="../assets/images/groups/link.png"
                  class="link-icon ms-2"
              />
            </a>
          </div>
          <div class="col-xl-6 text-container p-5">
            <div class="group-title color-dark mb-5">MATHNASIUM</div>
            <img
                alt="line"
                src="../assets/images/groups/dark-line.png"
                class="mb-5"
            />
            <div class="group-text color-dark">
              At Mathnasium Learning Centers, we make math make sense! Whether
              your child started out far behind or already ahead in math,
              Mathnasium will help them leap ahead because we know that any
              child can be successful in math—it’s a matter of teaching it in
              a way that makes sense to them. Our experienced math tutors
              utilize our proprietary teaching materials and techniques, The
              Mathnasium Method™, to deliver a customized learning plan
              designed to address each student's needs. Our instructional
              approach goes beyond traditional math tutoring to develop
              understanding and build a love for math.
            </div>
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="d-flex justify-content-center flex-column align-items-center">
          <div class="row mb-5">
            <div class="col-xl-12">
              <a href="/contact-us" class="btn-contact" style="text-decoration: none;">Tell
                us about your Project</a>
            </div>
          </div>

          <!--
                          <button class="btn-learn mb-5">Learn More</button>
          -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GVGroup',
  methods: {
    openTab($event, id, parent) {
      let i;
      let p = document.getElementsByClassName(`offer${parent}`)[0];
      let x = p.querySelectorAll(".offer");
      let tablinks = p.querySelectorAll(".circle");
      for (i = 0; i < x.length; i++) {
        x[i].classList.add("d-none");
      }
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" current", "");
      }
      event.currentTarget.className += " current";
      document.getElementById(id).className = document
          .getElementById(id)
          .className.replace("d-none", " d-block");
    },
  },
  async mounted() {
    let target = this.$route.query.target;
    if (target) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      document.getElementById(target).scrollIntoView();
    }
  },
}
</script>

<style>
@import '../assets/styles/groups.css';

.img-height-auto {
  height: auto;
}

@media (min-width: 1200px) and (max-width: 1600px) {
  .container-width {
    width: 88%;;
  }
}
</style>
